module.exports = __webpack_public_path__ + "static/media/info.1233a6a0.svg";